import { useCallback, useEffect, useState } from 'react'
import Particles, { initParticlesEngine } from '@tsparticles/react'
import type { Container, Engine } from '@tsparticles/engine'
// import { loadAll } from "@/tsparticles/all"; // if you are going to use `loadAll`, install the "@tsparticles/all" package too.
// import { loadFull } from "tsparticles"; // if you are going to use `loadFull`, install the "tsparticles" package too.
import { useAppSelector } from '../utils/redux/store'
// import { loadBasic } from "@tsparticles/basic"; // if you are going to use `loadBasic`, install the "@tsparticles/basic" package too.
import PALLETTE from '../utils/theme/pallette.module.scss'

import musicNote from '../assets/music-svgrepo-com.svg'

export default function MusicalBackground() {
  const particlesLoaded = useCallback(async (container?: Container) => {}, [])

  return (
    <Particles
      id="tsparticles"
      particlesLoaded={particlesLoaded}
      options={{
        background: {
          color: {
            value: PALLETTE.primaryColor,
          },
        },
        fpsLimit: 60,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: 'push',
            },
            onHover: {
              enable: true,
              mode: 'repulse',
            },
            // resize: true,
          },
          modes: {
            push: {
              quantity: 4,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: PALLETTE.secondaryColor,
          },
          links: {
            color: PALLETTE.secondaryColor,
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 1,
          },
          move: {
            direction: 'none',
            enable: true,
            outModes: {
              default: 'bounce',
            },
            random: false,
            speed: 3,
            straight: false,
          },
          number: {
            density: {
              enable: true,
            },
            value: 80,
          },
          opacity: {
            value: 0.7,
          },
          shape: {
            type: 'image',
            options: {
              image: [
                {
                  src: musicNote,
                  width: 32,
                  height: 32,
                },
              ],
            },
          },
          size: {
            value: { min: 8, max: 16 },
          },
        },
        detectRetina: true,
      }}
    />
  )
}
